import React, { useState } from "react";
import { Text } from "@/styles/reactnative";
import { CryptoVolumeHeader, CryptoVolumeSection } from "./styles";
import MarketTrendTabs from "../../MarketTrendTabs";
import CryptoVolumeGraph from "./CryptoVolumeGraph";
import { useTranslation } from "react-i18next";

const CryptoVolume = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("24h");
  const tabs = ["24h", "7d", "1m"];

  return (
    <CryptoVolumeSection>
      <CryptoVolumeHeader>
        <Text size={16} style={{ fontWeight: "600" }}>
          {t("volumeChangeDistribution")}
        </Text>
        <MarketTrendTabs tab={tab} setTab={setTab} tabs={tabs} />
      </CryptoVolumeHeader>
      <CryptoVolumeGraph />
      {/* <CryptoVolumeFooter /> */}
    </CryptoVolumeSection>
  );
};

export default React.memo(CryptoVolume);
